<div class="dialog-container">
  <div class="dialog-header">
    <h5 class="dialog-title">
      {{ (data.camera ? "web-camera" : "scanner") | translate }}
    </h5>
  </div>
  <div #activationModal class="dialog-body">
    <!-- Scanner -->
    @if (data?.scanner) {
      <app-code-scanner
        #scanner
        [height]="cameraHeight"
        [width]="cameraWidth"
        [hideZoom]="true"
        [hideSearching]="true"
        [hideScannerResult]="true"
        [scannerZoomIn]="scannerZoomIn"
        (scannerResult)="sendScanner($event)"
      ></app-code-scanner>
    }
    <!-- <app-zbar-wasm-scanner></app-zbar-wasm-scanner> -->

    <!-- Camera -->
    @if (data?.camera && cameraHeight && cameraWidth) {
      <app-web-camera
        #camera
        [height]="cameraHeight"
        [width]="cameraWidth"
        [videoOptions]="{
          width: { ideal: 1920 },
          height: { ideal: 1080 }
        }"
        [hideButton]="true"
        (webcamImage)="sendPhoto($event)"
      ></app-web-camera>
    }

    <!-- Zoom -->
    @if (data?.scanner) {
      <button class="activation-scanner-zoom" (click)="scannerZoomIn = !scannerZoomIn">
        @if (scannerZoomIn) {
          <i class="fa-solid fa-magnifying-glass-minus"></i>
        }
        @if (!scannerZoomIn) {
          <i class="fa-solid fa-magnifying-glass-plus"></i>
        }
      </button>
    }
  </div>

  <!-- Action -->
  <div
    class="dialog-footer"
    [ngClass]="{ 'activation-camera-footer': $safeNavigationMigration(data?.camera) }"
  >
    <!-- Photo -->
    @if (data?.camera) {
      <button class="activation-camera-button" (click)="takePhoto()">
        <i class="fas fa-camera"></i>
      </button>
    }
    @if (!data?.camera) {
      <button mat-button (click)="SessionDataService.sendDialogAction({ action: 'close' })">
        {{ "close" | translate }}
      </button>
    }
  </div>
</div>
